import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmart = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			width: 3,
			height: 13,
			fill: "var(--overrideColor,#FFD22F)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 21,
			y: 21,
			width: 3,
			height: 3,
			fill: "var(--overrideColor,#FFD22F)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 5,
			width: 3,
			height: 13,
			transform: "rotate(90 24 5)",
			fill: "var(--overrideColor,#FFD22F)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 5,
			width: 3,
			height: 3,
			fill: "var(--overrideColor,#F7A431)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5447 13.8084C3.5447 14.8432 4.30637 15.1457 6.22275 15.575C9.34706 16.2307 12.052 17.1642 11.9992 19.6864C11.9992 22.3606 9.87242 24 6.40682 24C3.93872 24 1.68056 23.2687 0 21.9567L1.83777 19.8379C3.30839 20.8722 4.88397 21.4018 6.56404 21.4018C8.79633 21.4018 9.13761 20.3928 9.13761 20.0903C9.13761 19.1315 8.06102 18.7281 5.8551 18.198C2.9671 17.5169 0.577599 16.6595 0.577599 14.2376C0.577599 11.6901 2.73029 10 5.9342 10C8.16649 10 9.97789 10.5296 11.5266 11.5887L10.0038 13.632C8.45454 12.6479 7.168 12.3707 5.82923 12.3707C4.48995 12.3707 3.5447 12.9256 3.5447 13.8084Z",
			fill: "var(--overrideColor,#FFD22F)"
		})
	]
});
export default SvgSmart;
